export default __webpack_public_path__ + "static/media/hörtest-avatar-04.0e541db8.svg";